import {stringify} from "querystring";
import $http from "../plugins/axios";

export const AuthService = {
    signIn(provider) {
        const openIdParams = {
            client_id: provider.client_id,
            scope: 'openid+profile+email+phone',
            response_type: 'code',
            redirect_uri: provider.redirect_uri
        }
        const openIdQueryParams = unescape(stringify(openIdParams));
        window.location.href = `${provider.oidc_endpoint}/protocol/openid-connect/auth?${openIdQueryParams}`
    },
    signOut(provider) {
        window.location.href =
            `${provider.oidc_endpoint}/protocol/openid-connect/logout?redirect_uri=${window.location.origin}?provider=${provider.name}`
    },
    getToken(provider, code, iss='') {
        let url = `${process.env.VUE_APP_FPTAI_MESSENGER_BACKEND_HOST}/security/${provider.name}/auth/token?code=${code}`
        if (iss) {
            url += `&iss=${iss}`
        }
        // return $http.get(`${process.env.VUE_APP_FPTAI_MESSENGER_BACKEND_HOST}/security/${provider.name}/auth/token?code=${code}`)
        return $http.get(url)
    },
    revokeToken() {
        return $http.post(`${process.env.VUE_APP_FPTAI_MESSENGER_BACKEND_HOST}/security/revoke-token/`)
    },
    getProvider(provider) {
        const redirect_uri = `${window.location.origin}/authentication/${provider}/complete`
        return {
            client_id: process.env[`VUE_APP_${provider.toUpperCase()}_CLIENT_ID`],
            redirect_uri: redirect_uri,
            oidc_endpoint: process.env[`VUE_APP_${provider.toUpperCase()}_OIDC_ENDPOINT`],
            name: provider
        }
    }
}

export default AuthService
